import React, { useState } from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../commons/Loader";
import { useGetUserDetailsQuery } from "../../../../store/admin/professionalUserInfo";
import MatchTabs from "../../../commons/MatchTabs";
import ProfessionalProfile from "./ProfessionalProfile";
import ProfessionalReviews from "./ProfessionalReviews";
import ProfessionalLeads from "./ProfessionalLeads";

const ProfessionalsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("User Profile");
  const { data: userDetails } = useGetUserDetailsQuery(id);
  const userInfo = userDetails?.data ?? {};

  const handleGoBack = () => {
    navigate(-1);
  };
  const handleTabChange = (tabName) => {
    setSelectedTab(tabName);
  };

  return (
    <>
      {!userDetails ? (
        <Loader isLoading={true} />
      ) : (
        <div className="col-span-12">
          <div className="flex items-center gap-[6px] xl:gap-[10px] mb-5 xl:mb-[30px]">
            <div className="flex items-center gap-[10px]">
              <ArrowLeftIcon
                className="w-6 h-6 text-[#485868] cursor-pointer"
                onClick={handleGoBack}
              />
              <h3
                className="text-xl xl:text-2xl font-normal leading-[130%] text-[#485868] cursor-pointer"
                onClick={handleGoBack}
              >
                Professional
              </h3>
            </div>
            <span className="text-[#485868]">&#8226;</span>
            <h3 className="text-xl xl:text-2xl font-bold leading-[130%] text-customGray">
              {userInfo?.first_name.concat(" ", userInfo.last_name ?? "")}
            </h3>
          </div>
          <div className="max-w-[345px] md:max-w-auto w-full md:w-[280px]">
            <MatchTabs
              selectedTab={selectedTab}
              onSelectTab={handleTabChange}
              isReview={!!userInfo}
              iShowLead={true}
            />
          </div>
          {selectedTab === "User Profile" && (
            <ProfessionalProfile userInfoDetail={userInfo} />
          )}
          {selectedTab === "Review" && userInfo && (
            <ProfessionalReviews userInfoDetail={userInfo} />
          )}
           {selectedTab === "Leads" && userInfo && (
            <ProfessionalLeads userInfoDetail={userInfo} />
          )}
        </div>
      )}
    </>
  );
};

export default ProfessionalsDetailPage;
